import request from "@/utils/request.js";

// 查询启用的数据
export function listEnableHxClassifyVo() {
    return request({
        url: "/website/classify/listEnableHxClassifyVo",
        method: "get",
    });
}

// 查询启用的分类数据
export function listEnableHxClassify() {
    return request({
        url: "/website/classify/listEnableHxClassify",
        method: "get",
    });
}
